import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoPoslovanjeEJS() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno poslovanje" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno poslovanje</h2>
              <p>
                <strong>Studijski program:</strong> Ekonomija javnog sektora
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno poslovanje
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Upoznavanje studenata sa suštinom i elementima međunarodnog
                poslovanja bez kojih je nemoguće obavljanje djelatnosti u
                međunarodnim preduzećima. Nakon uspješnog završetka ovog
                predmeta studenti će biti sposobni da u organizaciji u kojoj
                budu radili primjene stečena znanja teoretska i praktična.
                Takođe cilj je i da se studenti upoznaju sa aktuelnom zakonskom
                regulativom kao što su carinski zakon zakon o deviznom
                poslovanju i slični zakoni koji omogućavaju spoljno-trgovinski
                promet u raznim formama.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Na kraju predmeta studenti su osposobljeni da samostalno
                obavljaju poslove u preduzećima koja se bave međunarodnom
                trgovinom kao i svim ostalim organizacijama koje obavljaju
                spoljnotrgovinske poslove.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Međunarodno poslovanje (pojam značaj i
                uloga); međunarodno trgovinski bilans i usluge vezane za robni
                promet međunarodne organizacije (WTO IMF IBRD MTK); međunarodna
                kupoprodaja rizici i robni dokumenti specifičnosti
                spoljnotrgovinskih poslova i viši oblici. Kalkulacije i poslovi
                kontrole u spoljnotrgovinskom poslovanju. Praktična nastava:
                Prati teorijsku nastavu i obuhvata primjene iz prakse diskusije
                na zadatu temu i kreativne radionice.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava je u skladu sa zahtjevima predmeta interaktivna. Težište
                je na razvijanju receptivne i automatizaciji reproduktivne
                sposobnosti uz pomoć različitih tipova vježbi i simulacije
                tipičnih poslovnih situacija i razgovora.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Ekonomija obima, nesavršena konkurencija i međunarodna
                      razmjena; uvodna razmatranja spoljnotrgovinskog poslovanja
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Privredni rast i međunarodna trgovina; pojam i uloga
                      spoljnotrgovinskog poslovanja
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Spoljnotrgovinska ograničenja; carine; necarinske barijere
                      i novi protekcionizam; Razvoj spoljne trgovine
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Ekonomske integracije: carinske unije i zone slobodne
                      trgovine; ekspanzija globalizacije i strukturne promjene
                      svjetske trgovine
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodna trgovina i ekonomski razvoj; globalizacija i
                      konkurentske prednosti država
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodno kretanje resursa i multinacionalne
                      korporacije; međunarodno kretanje faktora
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Devizna tržišta i devizni kursevi ; određivanje deviznog
                      kursa; platni biznis i devizno tržište
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>
                      određivanje deviznog kursa; carfinski sistem i carinske
                      tarife
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>
                      Evropski monetarni sistem; protekcionizam i restriktivne
                      mjere u međunarodnom poslovanju
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>Koordinacija makroekonomskih politika</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Medjunarodni monetarni sistem; međunarodne institucije
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>Crna Gora i međunarodne ekonomske institucije</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>
                      Međunarodno poslovanje u okviru regiona; retrospektiva
                      pređenog gradiva
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.30h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3.00h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.30h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoPoslovanjeEJS;
